module.exports = {
      id: "more-usage",
      viewBox: "0 0 9.418 9.418",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#more",
      toString: function () {
        return this.url;
      }
    }